import React, { useState } from 'react';
import { Building2, Plus, ChevronDown, Check, Video, FileText, Megaphone } from 'lucide-react';

export function ClientSelectorModal({
  isOpen,
  onClose,
  clients = [],
  activeClientId,
  onSelectClient,
  onCreateClient
}) {
  const [isCreating, setIsCreating] = useState(false);
  const [newClientName, setNewClientName] = useState('');
  const [newClientNiche, setNewClientNiche] = useState('');
  const [newClientContract, setNewClientContract] = useState('2 videos semanales');

  if (!isOpen) return null;

  const handleCreate = (e) => {
    e.preventDefault();
    if (!newClientName.trim()) return;
    onCreateClient({
      name: newClientName.trim(),
      niche: newClientNiche.trim() || 'General',
      contract: newClientContract.trim()
    });
    setNewClientName('');
    setNewClientNiche('');
    setIsCreating(false);
  };

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(5, 7, 12, 0.85)',
      backdropFilter: 'blur(16px)',
      zIndex: 1200,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: '#111420',
        borderRadius: '16px',
        border: '1px solid rgba(168, 85, 247, 0.3)',
        boxShadow: '0 25px 60px -15px rgba(0,0,0,0.9), 0 0 40px rgba(168,85,247,0.15)',
        width: '100%',
        maxWidth: '640px',
        maxHeight: '90vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '24px'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ background: 'rgba(168,85,247,0.15)', padding: '8px', borderRadius: '10px', color: '#c084fc' }}>
              <Building2 size={22} />
            </div>
            <div>
              <h2 style={{ fontSize: '17px', fontWeight: 800, color: '#f8fafc', margin: 0 }}>
                Directorio de Empresas & Clientes B2B
              </h2>
              <p style={{ fontSize: '11px', color: '#94a3b8', margin: '2px 0 0 0' }}>
                Organiza las campañas, avatares, guiones e historial de videos por cliente
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{ background: 'transparent', border: 'none', color: '#64748b', fontSize: '20px', cursor: 'pointer' }}
          >
            ✕
          </button>
        </div>

        {/* Lista de Empresas */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {clients.map((client) => {
            const isSelected = client.id === activeClientId;
            const historyCount = (client.videoHistory && client.videoHistory.length) || 0;
            return (
              <div
                key={client.id}
                onClick={() => {
                  onSelectClient(client.id);
                  onClose();
                }}
                style={{
                  background: isSelected ? 'rgba(168, 85, 247, 0.12)' : '#161926',
                  border: isSelected ? '2px solid #a855f7' : '1px solid rgba(255,255,255,0.08)',
                  borderRadius: '12px',
                  padding: '14px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  transition: 'all 0.15s ease'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{
                    width: '38px',
                    height: '38px',
                    borderRadius: '10px',
                    background: isSelected ? '#a855f7' : 'rgba(255,255,255,0.06)',
                    color: isSelected ? '#fff' : '#94a3b8',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 800,
                    fontSize: '15px'
                  }}>
                    {client.name.substring(0, 2).toUpperCase()}
                  </div>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: 800, color: isSelected ? '#fff' : '#f8fafc' }}>
                      {client.name}
                    </div>
                    <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>
                      Nicho: <span style={{ color: '#c084fc' }}>{client.niche}</span> • Contrato: {client.contract}
                    </div>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{
                    fontSize: '11px',
                    background: 'rgba(255,255,255,0.06)',
                    color: '#cbd5e1',
                    padding: '3px 8px',
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}>
                    <Video size={12} /> {historyCount} videos
                  </span>
                  {isSelected && (
                    <div style={{ background: '#10b981', color: '#fff', padding: '3px', borderRadius: '50%' }}>
                      <Check size={12} />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* Formulario de Nueva Empresa */}
        {isCreating ? (
          <form onSubmit={handleCreate} style={{
            background: 'rgba(255,255,255,0.02)',
            border: '1px dashed rgba(168,85,247,0.4)',
            borderRadius: '12px',
            padding: '14px',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px'
          }}>
            <div style={{ fontSize: '12px', fontWeight: 800, color: '#c084fc' }}>
              Registrar Nueva Empresa / Cliente
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
              <input
                type="text"
                value={newClientName}
                onChange={(e) => setNewClientName(e.target.value)}
                placeholder="Nombre (ej. Osmex, Ayuntamiento)"
                style={{
                  background: '#161926',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '8px',
                  padding: '8px 10px',
                  color: '#fff',
                  fontSize: '12px',
                  outline: 'none'
                }}
                required
              />
              <input
                type="text"
                value={newClientNiche}
                onChange={(e) => setNewClientNiche(e.target.value)}
                placeholder="Nicho (ej. Tratamiento de Aguas)"
                style={{
                  background: '#161926',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '8px',
                  padding: '8px 10px',
                  color: '#fff',
                  fontSize: '12px',
                  outline: 'none'
                }}
              />
            </div>
            <input
              type="text"
              value={newClientContract}
              onChange={(e) => setNewClientContract(e.target.value)}
              placeholder="Contrato (ej. 2 videos semanales)"
              style={{
                background: '#161926',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '8px',
                padding: '8px 10px',
                color: '#fff',
                fontSize: '12px',
                outline: 'none'
              }}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '4px' }}>
              <button
                type="button"
                onClick={() => setIsCreating(false)}
                style={{ background: 'transparent', border: 'none', color: '#94a3b8', fontSize: '12px', cursor: 'pointer' }}
              >
                Cancelar
              </button>
              <button
                type="submit"
                style={{
                  background: 'linear-gradient(135deg, #a855f7, #6366f1)',
                  border: 'none',
                  color: '#fff',
                  padding: '6px 14px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: 700,
                  cursor: 'pointer'
                }}
              >
                Guardar Empresa
              </button>
            </div>
          </form>
        ) : (
          <button
            type="button"
            onClick={() => setIsCreating(true)}
            style={{
              padding: '12px',
              borderRadius: '10px',
              border: '1px dashed rgba(255,255,255,0.15)',
              background: 'transparent',
              color: '#c084fc',
              fontSize: '12px',
              fontWeight: 700,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px'
            }}
          >
            <Plus size={15} /> Añadir Otra Empresa
          </button>
        )}
      </div>
    </div>
  );
}
